import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { AppState } from '../app.service';
import { Title } from './title';


@Component({
  /**
   * The selector is what angular internally uses
   * for `document.querySelectorAll(selector)` in our index.html
   * where, in this case, selector is the string 'home'.
   */
  selector: 'getZinc',  // <home></home>
  /**
   * We need to tell Angular's Dependency Injection which providers are in our app.
   */
  providers: [
    Title
  ],
  /**
   * Our list of styles in our component. We may add more to compose many styles together.
   */
  styleUrls: ['./getZinc.component.scss'],
  /**
   * Every Angular template is first compiled by the browser before Angular runs it's compiler.
   */
  templateUrl: './getZinc.component.pug'
})


export class GetZincComponent implements OnInit {
  /**
   * Set our default values
   */
  public localState = { value: '' };
  public buttons: InstallBtn[] = [];
  private updUrl: string = 'http://zeiza.eu:6970/';
  public selectedPricing: Pricing;
  public selectedValuePcs: number = 1;
  


  public pricing: Pricing[] = [];


  pcs: Pcs[] = [
    { value: 1, viewValue: '1 PC' },
    { value: 2, viewValue: '2 PC' },
    { value: 3, viewValue: '3 PC' },
    { value: 4, viewValue: '4 PC' }

  ];


  getTotal() {
    // console.log('index', this.selectedPricing);
    return this.selectedPricing.amount * this.selectedValuePcs;

  }
  savingKek(kek) {
    let costsStorage: number[] = []
    let x = this.pricing;
    for (let i = 0; i < x.length; i++) {
      costsStorage.push(x[i].amount / x[i].days);
    }
    let maxValue = Math.max(...costsStorage);
    let currentCost = kek.amount / kek.days;
    let saving = Math.round(((maxValue / currentCost) * 100) - 100);
    return saving;
  }





  /**
   * TypeScript public modifiers
   */
  constructor(
    public appState: AppState,
    public title: Title,
    private http: HttpClient
  ) { }

  public ngOnInit() {
    // console.log('hello `Get Zinc` component');

    this.http.get(remoteApiHost + 'getPricing').subscribe((data: any) => {
      // console.log('get pricing', data[1].amount);
      for (let i = 0; i < data.length; i++) {
        this.pricing.push({
          amount: data[i].amount,
          days: data[i].days,
          periodName: data[i].periodName
        });
      }
      this.selectedPricing = this.pricing[0];

      // console.log('object', this.pricing);
    });
    /**
     * this.title.getData().subscribe(data => this.data = data);
     */
    this.http.get(this.updUrl + 'versions.nsis.json').subscribe((data: any) => {
      this.buttons = [];
      if (data.latest && data.versions && data.versions.length > 0) {
        for (let ver of data.versions) {
          if (ver.version === data.latest) {
            for (let installer of ver.installers) {
              this.buttons.push({
                arch: installer.arch,
                pth: this.updUrl + installer.path,
                version: ver.version
              });
            }
          }
        }
      }
    })
  }

  public buy(pro = false) {
    let body = null;
    if (pro) {
      body = {
        selectedValuePCs: this.selectedValuePcs,
        selectedPricing: this.selectedPricing
      };
    }
    this.http.post(remoteApiHost + 'payment/pay', body).subscribe((data: any) => {
       if (data.redirectTo) {
         window.location.href = data.redirectTo;
      }
    });
  }

  public submitState(value: string) {
    // console.log('submitState', value);
    this.appState.set('value', value);
    this.localState.value = '';
  }
}

interface InstallBtn {
  version: string;
  pth: string;
  arch: string;
}

export interface Pcs {
  value: number;
  viewValue: string;
}

export interface Pricing {
  days: number;
  amount: number;
  periodName: string;
}



// WEBPACK FOOTER //
// ./src/app/getZinc/getZinc.component.ts